module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social"
  }, [_c('h5', [_vm._v("Follow us:")]), _vm._v(" "), _c('ul', {
    staticClass: "social-icons"
  }, [_c('li', [_c('a', {
    staticClass: "social-icon",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "social-icon",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "social-icon",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "social-icon",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31b85ff2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Social.vue
// module id = 20
// module chunks = 0